import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendGA4Pageview } from 'common/helpers/ga4';

const usePageTracking = props => {
  const location = useLocation();

  useEffect(() => {
    sendGA4Pageview({
      page: location.pathname,
      contentGroup: props?.path,
    });
  }, [location, props?.path]);
};

export default usePageTracking;
